import { Component } from '@angular/core';
import { GenericNavigationStore } from 'ccc-commons/core';


@Component({
  templateUrl: './full-width.component.html',
  selector: 'ccc-cca-full-width-container'
})
export class FullWidthComponent {
  constructor (public navigationStore: GenericNavigationStore) {}
}
